import React, { useState, useEffect } from "react";

import { KeyboardArrowLeft } from "@material-ui/icons";
import { useAlert } from "react-alert";
import PropTypes from "prop-types";

import { consumerSendVerificationCode } from "../../../../lib/api/auth";
import { formattingPhoneNumber, unformattedPhoneNumber } from "../../../../lib/helpers/formatters";
import { ErrorMessage } from "../ErrorMessage";
import { CustomButton } from "../../../../components/ui-kit/CustomButtom";

import { useTranslation } from 'react-i18next';

import "./style.scss";

export const AuthFormConfirm = ({
  handleConfirmChange,
  handleConfirm,
  handleGoBack,
  email,
  phone,
  isButtonDisabled,
  errorMessage,
}) => {
  const alert = useAlert();

  const { t } = useTranslation();

  const [counter, setCounter] = useState(90);
  const [isConfirmationDisabled, setIsConfirmationDisabled] = useState(true);

  useEffect(() => {
    counter > 0 &&
      setTimeout(() => {
        if (counter <= 10) {
          setCounter(`0${counter - 1}`);
        } else {
          setCounter(counter - 1);
        }
      }, 1000);
  }, [counter]);

  const handleChange = (e) => {
    if (e.target.value.length === 8) {
      handleConfirmChange(e);
      setIsConfirmationDisabled(false);
    } else {
      setIsConfirmationDisabled(true);
    }
  };

  const resendCode = async () => {
    let prepareRequest = {};

    if (phone) {
      prepareRequest = {
        phone_number: unformattedPhoneNumber(phone),
      }
    } else if (email) {
      prepareRequest = {
        email: email,
        login_flow: true
      }
    }

    const data = await consumerSendVerificationCode(prepareRequest);
    if (data.success === "True") {
      setCounter(90);
    } else {
      alert.error(data.message);
    }
  };

  return (
    <div className="auth-form-confirm">
      <div className="auth-form__header">
        <h3 className="heading heading-1">{t("Two-Factor Authentication")}</h3>
        {email && (
          <p className="heading heading-body-medium">
            {t("For additional security, we sent a verification code to")} {" "}
            <span className="font-weight-bold">{email}</span>
          </p>
        )}
        {phone && (
          <p className="heading heading-body-medium">
            {t("For additional security, we sent a verification code to")} {" "}
            <span className="font-weight-bold">
              {phone && formattingPhoneNumber(phone)}
            </span>
          </p>
        )}
        <button
          className="button button-text--simple"
          onClick={() => handleGoBack()}
        >
          <KeyboardArrowLeft />
        </button>
      </div>
      {errorMessage ? (
        <ErrorMessage
          errorMessage={errorMessage}
          className="error-message confirm"
        />
      ) : null}
      <div className="form-group">
        <label htmlFor="email">{t("Code")}</label>
        <input
          onChange={handleChange}
          className="form-control form-control--confirm"
          type="number"
          name="verification_code"
          id="verification_code"
          placeholder="XXXXXXXX"
        />
      </div>
      <div className="auth-form__submit">
        <CustomButton
          text={t("Verify")}
          size="large"
          onClickHandler={handleConfirm}
          disabled={isConfirmationDisabled || isButtonDisabled}
          buttonId="verify2FA"
        />
      </div>
      {counter > 0 ? (
        <div className="timer">
          <p>{t("Resend code in")}</p>
          <p>&nbsp;</p>
          <p>00 : {counter}</p>
        </div>
      ) : (
        <CustomButton
          text={t("Resend Code")}
          type="secondary"
          onClickHandler={resendCode}
        />
      )}
    </div>
  );
};

AuthFormConfirm.propTypes = {
  handleConfirmChange: PropTypes.func,
  handleConfirm: PropTypes.func,
  handleGoBack: PropTypes.func,
  email: PropTypes.string,
  phone: PropTypes.string,
  isButtonDisabled: PropTypes.bool,
  errorMessage: PropTypes.string,
};
